<template>
  <div>
    <MainHeader />

    <v-select
      v-model="currentComponent"
      :items="ANALYZER_COMPONENTS"
      item-text="label"
      item-value="componentName"
      class="select-components ma-md-3 mt-3"
      single-line
      solo
      dense
      background-color="primary"
      dark
      @change="changeCurrentComponent"
    />

    <component :is="currentComponent" />
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import DifferenceInDestCountriesConfig from "@/components/analyzer-tables/DifferenceInDestCountriesConfig";
import Summaries from "@/components/analyzer-tables/Summaries";
import MissingCorridors from "@/components/analyzer-tables/MissingCorridors";
import DeviatedEndRateFromMarket from "@/components/analyzer-tables/DeviatedEndRateFromMarket";
import ExistingManualRates from "@/components/analyzer-tables/ExistingManualRates";

const ANALYZER_COMPONENTS = [
  {
    componentName: 'DifferenceInDestCountriesConfig',
    label: 'Difference in dest countries config',
  },
  {
    componentName: 'Summaries',
    label: 'Summaries'
  },
  {
    componentName: 'MissingCorridors',
    label: 'Missing corridors'
  },
  {
    componentName: 'DeviatedEndRateFromMarket',
    label: 'Deviated End Rate From Market'
  },
  {
    componentName: 'ExistingManualRates',
    label: 'Existing Manual Rates'
  }
]

export default {
  name: "Analyzer",
  components: {
    MainHeader,
    DifferenceInDestCountriesConfig,
    Summaries,
    MissingCorridors,
    DeviatedEndRateFromMarket,
    ExistingManualRates,
  },
  data() {
    return {
      currentComponent: '',
    }
  },
  created() {
    this.ANALYZER_COMPONENTS = ANALYZER_COMPONENTS;

    this.restorePageFromURL();
  },
  methods: {
    restorePageFromURL() {
      if (!this.$route.query) {
        this.currentComponent = ANALYZER_COMPONENTS[1].componentName;
        return;
      }

      const query = this.$route.query;
      const type = query?.type;
      if (type) {
        const currentComponent = ANALYZER_COMPONENTS.find(item => item.componentName === type);
        this.currentComponent = currentComponent?.componentName || ANALYZER_COMPONENTS[1].componentName;
      }
    },
    changeCurrentComponent(newValue) {
      this.$router.push({
        name: 'Analyzer',
        query: {
          type: newValue
        }
      });
    }
  }
}
</script>

<style scoped>
.select-components {
  min-width: 250px;
  max-width: 250px;
  height: 38px;
}
</style>